import React, { useEffect,useState,createRef,useIntl } from 'react';
import {connect} from 'react-redux';
import { Button, Modal } from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import CustomSelect from '../../components/custom-select/CustomSelect';
import AlertDialog from '../../components/alert-dialog/AlertDialog';
import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import moment from 'moment';
import * as RestService from '../../services/eisRest';
import sk from 'date-fns/locale/sk';
import "react-datepicker/dist/react-datepicker.css";
registerLocale('sk', sk)




  const AttendanceModal = (props) => {

   

    const {t,i18n} = useTranslation();    
  
    const [isOpen, setIsOpen] = useState(false);
    const [month, setMonth] = useState(null);  
    const [selectedRecord, setSelectedRecord] = useState();
    const [entityId, setEntityId] = useState();
    const [attendance, setAttendance] = useState([]);  
    const [openAlertDialog, setOpenAlertDialog] = useState(false);    
    const dialogRef = createRef();
    const [userList,setUserList] = useState([]);
    const [userId,setUserId] = useState(props.user.id);
    const [disabledSaveButton, setDisabledSaveButton] = useState(false);
  
  
    const hideModal = () => {
      setIsOpen(false);
      showChanged(false);
    };

    const showChanged = (newStatus) => {
      props.parentCallback(newStatus);
    }
    
    const deleteRecord = () => {
      setOpenAlertDialog(true);
    };

    useEffect(() => {
      formik.resetForm();
      setIsOpen(props.modal);
      showChanged(props.modal);

    }, [props.modal])

    
    useEffect(() => {      
      
      setSelectedRecord(props.selectedRecord);
      RestService.callAnyApi('attendance/getAttendance?id='+props.selectedRecord, null)
      .then((data) => {          
           setAttendance(data);         
      })
      .catch((error) => {
        console.log(error);
      });

    }, [props.selectedRecord])

  
    useEffect(() => {      
      setEntityId(props.entityId);
    }, [props.entityId])

   

    

    
    const showError = (error,serverMessage) =>{
      if(serverMessage==null){
          toast.error(
            (error.response &&
                error.response.data &&
                error.response.data.message &&
                error.responseMessage) ||
                t('general.message.failed')
          );
        }else{
          toast.error(serverMessage);
        }
    }

    const save = (url,values) => {
         
  //    attendance.entityId=props.entityId;
    //  attendance.bankId=values.bankId;
    //  attendance.currency=values.currency;
    //  attendance.departmentId=values.departmentId;
     // attendance.iban=values.iban;

      setDisabledSaveButton(true) ;

      attendance.month =  moment(month).format("MM-YYYY");
      attendance.userId = userId;
      
     
      RestService.callAnyApi(url, attendance)
          .then((data) => {                                                 
                      if(data.responseMessage==='OK'){
                          toast.success(t('general.message.saveSucceed'));                                              
                          hideModal();
                      }else{
                          showError(null,data.responseMessage);
                      }
                  
                      setDisabledSaveButton(false) ;
          })
          .catch((error) => {               
            showError(error,null);
            setDisabledSaveButton(false) ;
          });
    };

    const formik = useFormik({
      enableReinitialize: true,
      initialValues: {    
          userId: props.user ? props.user.id : ''
      },
      validationSchema: Yup.object({
      //   month: Yup.string()     
       //   .required(t('general.message.required'))
       //   currency: Yup.string()     
       //   .required(t('general.message.required')),
        //  iban: Yup.string()     
         // .required(t('general.message.required')),
      }),
      onSubmit: (values) => {           
          save('attendance/saveAttendance',values);         
      }
    });

    useEffect(() => {
      
      RestService.callAnyApi('user/getUsersSelectList', null).then((data) => {        
        setUserList(data);
      }).catch((error) => {});      
       
    }, []);

    return (
      <>    
        <div className="modal-container">
                  <Modal
                    show={isOpen}
                    onHide={hideModal}
                    container={this}
                    aria-labelledby="contained-modal-title"
                    centered
                    //size="lg"
                    ref={dialogRef}
                  >
                    <form onSubmit={formik.handleSubmit}>     
                    <Modal.Header closeButton>
                      <Modal.Title id="contained-modal-title">{t('attendance.label.newMonth')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                                
                        <div className="row" style={props.user.accessRights && props.user.accessRights.rightsEntityAttendanceAdmin === 1 ? {} : { display: 'none' }} >            
                                    <div class="col-12">
                                        <div class="form-group">
                                          <label>{t('attendance.label.employee')}</label>                               
                                          <CustomSelect
                                                className='input'
                                                onChange={value=> {formik.setFieldValue('userId',value.value); setUserId(value.value);}}
                                                value={formik.values.userId}
                                                options={userList}     
                                          />                                
                                        </div>
                                        {formik.touched.userId && formik.errors.userId ? (
                                          <div style={{ color: 'red' }}>{formik.errors.userId}</div>
                                        ) : null} 
                                      </div>                   
                         </div>         

                         <div className="row"> 
                                <div className="col-12">
                                    <label>{t('attendance.label.month')}</label>        
                                    <div className="form-group">
                                                                                                                  
                                            <DatePicker
                                                className='form-control'                                         
                                                selected={month}
                                                onChange={(value) => setMonth(new Date(value).getTime())}
                                                dateFormat="MM-yyyy"
                                                showMonthYearPicker
                                                locale={i18n.language}                                            
                                            />                                                   						
                                    </div>
                               </div>
                         </div>      

                     
                           

                    </Modal.Body>
                    <Modal.Footer>                                                  
                          <Button className="btn-primary" type="submit"   disabled={disabledSaveButton}>{t('general.button.save')}</Button>    
                          <Button className="btn-default" onClick={hideModal}>{t('general.button.cancel')}</Button>
                    </Modal.Footer>
                    </form>  
                                        
                  </Modal>                                      
                </div>
               
            
     
      </>
    );
  };

  const mapStateToProps = (state) => ({
    user: state.auth.currentUser
  });
  

  export default connect(mapStateToProps, null)(AttendanceModal);